module.exports = {"brand":"Voice Caddie Smart Golf Service","idPlaceholder":"Enter your ID","pwPlaceholder":"Enter your password","staySignedIn":"Stay signed in","login":"Log In","forgotPassword":"Forgot your password?","enterIdPw":"Please enter your ID and password"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/en/lo001.json
// module id = OuGL
// module chunks = 2